export namespace SearchHelper {
    export function isContained(s1: string, s2: string) {
        if (!s1 || s1.length === 0) return true;
        if (!s2 || s2.length === 0) return true;
        return s1.toLowerCase().indexOf(s2.toLowerCase()) != -1;
    }
}